import { Link } from 'react-router-dom';
import { characters } from '@/mocks/characters';

const featured = characters.slice(0, 6);

export default function FeaturedCharacters() {
  return (
    <section className="bg-background-100/70 border-y border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-18">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-accent-700">
              <i className="ri-fire-line" />
              本周热选
            </span>
            <h2 className="mt-1 font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门角色推荐</h2>
          </div>
          <Link to="/characters" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-600 whitespace-nowrap">
            进入角色百科
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-5 sm:grid-cols-3 lg:grid-cols-6">
          {featured.map((char) => (
            <Link
              key={char.id}
              to={`/character/${char.id}`}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-transform hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={char.image}
                  alt={`${char.name} - ${char.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-xs font-bold text-primary-900">
                  {char.rank}
                </span>
                <span className="absolute right-2 top-2 rounded-full bg-background-950/55 px-2 py-0.5 text-xs text-background-50 backdrop-blur">
                  {char.category}
                </span>
              </div>
              <div className="p-3">
                <h3 className="truncate font-medium text-sm text-foreground-950">{char.name}</h3>
                <p className="mt-0.5 truncate text-xs text-foreground-500">{char.title}</p>
                <p className="mt-2 flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-mic-line text-accent-600" />
                  {char.seiyuuName}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}